import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import AddStartupComp from './AddStartupComp'

function AddStartup() {

  return (
    <div className='mainContainer'>
            <Leftmenu/>
            <div className='theMainContainer'>
              <Dashnav/>
              <AdmissionTopNotice/>
              <AddStartupComp/>
            </div>
    </div>  
  )
}

export default AddStartup